import {AccountSummary} from './accountSummary.model';
import {LovValueSummary} from '../../../modules/common/lov/lov-value/api/model/lovValueSummary.model';
import {OfficeModel} from '../../../modules/office/api/model/office.model';
import {UserSummary} from '../../../modules/account/modules/user/api/entity/userSummary.model';
import {Moment} from 'moment-timezone';


export class Account {
    summary: AccountSummary;
    expirationDate: Moment;
    modules: LovValueSummary[] = [];
    // subscriptions: Subscription[] = [];
    users: UserSummary[] = [];
    offices: OfficeModel[] = [];
    partnerIds: number[] = [];

}
